import { IBoar } from "../boar";

export default class AnomalieViewModel {
    id: number;
    name: string;
    coordonnates: string;
    description: string;
    severity: string; // e.g., 'low', 'medium', 'high'
    boar?: IBoar;

    constructor(id: number, name: string, coordonnates: string, description: string, severity: string, boar?: IBoar) {
        this.id = id;
        this.name = name;
        this.coordonnates = coordonnates;
        this.description = description;
        this.severity = severity;
        this.boar = boar;
    }
}
